import { Auth } from '@aws-amplify/auth'
import { mapGetters } from 'vuex'
import axios from 'axios'
import Cookie from 'js-cookie'

import { track } from '@/services/tracking'
import router from '@/router'
import { isSAE } from '@/helpers/oidc'

const SAE_LOGOUT = process.env.VUE_APP_ENV === 'production' ? 'https://sso.shop-apotheke.com' : 'https://sso-ref.sae.systems'

// Renderless component as we don't need any DOM here
export default {
  computed: {
    ...mapGetters({
      cognitoAppClientId: 'site/cognitoAppClientId',
      cognitoDomainUrl: 'site/cognitoDomainURL',
      currentRootUrl: 'site/currentRootUrl'
    })
  },
  methods: {
    async marcLogout () {
      try {
        await axios.post(`${window.location.origin}/api/v2/login/logout`)
        track({ name: 'success', params: { name: 'logout' } })
      } catch (error) {
        if (window.newrelic) {
          window.newrelic.noticeError(error)
        }
      }
    },
    async clientSignOut () {
      await this.marcLogout()
      window.localStorage.removeItem('ls.user')
      window.sessionStorage.removeItem('questionnaireResponse')
      await Auth.signOut({ global: true })
    }
  },
  async mounted () {
    const IS_OIDC = await isSAE()
    const WAS_OIDC = (Cookie.get('logout_from_sae') === 'true')

    track({ name: 'page view', params: { module: 'logout' } })

    if (!IS_OIDC && !WAS_OIDC) {
      await this.clientSignOut()
    }

    if (IS_OIDC) {
      Cookie.set('logout_from_sae', 'true')
      await this.clientSignOut()
      window.location.assign(`https://${this.cognitoDomainUrl}/logout?client_id=${this.cognitoAppClientId}&logout_uri=${this.currentRootUrl}auth/logout`)
      return
    }

    if (WAS_OIDC) {
      // For now, we assume it's SAE. We need to later on improve this
      Cookie.remove('logout_from_sae')
      window.location.assign(`${SAE_LOGOUT}/session/end`)
      return
    }

    router.push({ name: 'login' })
  },
  render: () => null
}
